<script>
import orderConfirmationImage from "@/assets/order-confirmation.png";
import paymentImage from "@/assets/payment.png";
import zoomedOutImage from "@/assets/zoomed-out.png";
import zoomedInImage from "@/assets/zoomed-in.png";
import IntroHero from "@/components/IntroHero";
import CaseStudySection from "@/components/CaseStudySection";
import ZoomIllustration from "@/components/illustrations/Zoom";

export default {
  name: "Home",
  components: {
    IntroHero,
    CaseStudySection,
    ZoomIllustration
  },
  data: () => {
    return {
      orderConfirmationImage,
      paymentImage,
      zoomedInImage,
      zoomedOutImage
    };
  }
};
</script>

<template>
  <div>
    <intro-hero />
    <case-study-section
      title="Bringing the farmers market online"
      description="A look into how to give a leg up to small business food vendors."
    >
      <template #image>
        <img class="order-confirmation-image" :src="orderConfirmationImage" />
        <img class="payment-image" :src="paymentImage" />
      </template>
    </case-study-section>
    <case-study-section
      title="Battling for features on a cross functional team"
      description="Deep dive into the what and how of choosing features for customers."
      reverse
    >
      <template #image>
        <img class="zoomed-out-image" :src="zoomedOutImage" />
        <img class="zoomed-in-image" :src="zoomedInImage" />
        <zoom-illustration class="zoom-illustration" />
        <div class="zoom-box-illustration" />
      </template>
    </case-study-section>
  </div>
</template>

<style>
.order-confirmation-image {
  position: absolute;
  height: 443px;
  top: 24px;
  right: 328px;
}

.payment-image {
  position: absolute;
  height: 328px;
  right: 24px;
  bottom: 32px;
}

.zoomed-out-image {
  position: absolute;
  height: 508px;
  top: 10px;
  left: 537px;
}

.zoomed-in-image {
  position: absolute;
  height: 463px;
  top: 33px;
  left: 24px;
  z-index: 1;
}

.zoom-illustration {
  position: relative;
  top: 48px;
  left: 32px;
}

.zoom-box-illustration {
  position: absolute;
  width: 213px;
  height: 215px;
  left: 562px;
  top: 157px;

  background: rgba(76, 76, 191, 0.1);
  border: 1px solid #4c4cbf;
  box-sizing: border-box;
  border-radius: 3px;
}
</style>
